import React from 'react'
import PropTypes from 'prop-types'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import { getEnvVar } from '@mc/client-env'
import { Button, IconSocialFacebookDefault } from '@mc/design-system'
import { isInAppBrowser } from '@mc/devices'

const FacebookButton = ({
  autoLoad = false,
  onLogin,
  children,
  userAgent = '',
  onClick,
}: {
  autoLoad?: boolean
  onLogin: () => void
  children: React.ReactNode
  userAgent?: string
  onClick?: () => void
}) => {
  // see isInAppBrowser to understand why
  if (isInAppBrowser(userAgent)) return null

  return (
    <FacebookLogin
      cookie
      autoLoad={autoLoad}
      isMobile={false}
      appId={getEnvVar('FACEBOOK_KEY')}
      fields='name,email,picture'
      onClick={onClick}
      callback={onLogin}
      scope='public_profile, email'
      render={(props: { onClick: () => void }) => (
        <Button kind='facebook' onClick={props?.onClick} fullWidth>
          <IconSocialFacebookDefault size='lg' className='mc-mr-3' />
          {children}
        </Button>
      )}
    />
  )
}

FacebookButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]),
  autoLoad: PropTypes.bool,
  onLogin: PropTypes.func,
  userAgent: PropTypes.string,
}

FacebookButton.defaultProps = {
  autoLoad: false,
  userAgent: '',
}

export default FacebookButton
